import { render } from "./SaveLabelModal.vue?vue&type=template&id=856c2c24&scoped=true"
import script from "./SaveLabelModal.vue?vue&type=script&lang=js"
export * from "./SaveLabelModal.vue?vue&type=script&lang=js"

import "./SaveLabelModal.vue?vue&type=style&index=0&id=856c2c24&lang=scss&scoped=true"
import "./SaveLabelModal.vue?vue&type=style&index=1&id=856c2c24&lang=scss"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-856c2c24"]])

export default __exports__